const IMAGE_PLACEHOLDER =
  '<svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="image" class="svg-inline--fa fa-image" role="img" xmlns="http://www.w3.org/2000/svg" height="75px" width="75px" viewBox="0 0 512 512"><path fill="#dddddd" d="M152 120c-26.51 0-48 21.49-48 48s21.49 48 48 48s48-21.49 48-48S178.5 120 152 120zM447.1 32h-384C28.65 32-.0091 60.65-.0091 96v320c0 35.35 28.65 64 63.1 64h384c35.35 0 64-28.65 64-64V96C511.1 60.65 483.3 32 447.1 32zM463.1 409.3l-136.8-185.9C323.8 218.8 318.1 216 312 216c-6.113 0-11.82 2.768-15.21 7.379l-106.6 144.1l-37.09-46.1c-3.441-4.279-8.934-6.809-14.77-6.809c-5.842 0-11.33 2.529-14.78 6.809l-75.52 93.81c0-.0293 0 .0293 0 0L47.99 96c0-8.822 7.178-16 16-16h384c8.822 0 16 7.178 16 16V409.3z"></path></svg>';

const PlaceholderImageCache = {
  placeholderImage: null as HTMLImageElement | null,

  // We could call this upon first load, since we are probably almost always
  // have something that will use it, but our CI env doesn't have decode defined
  // on HTMLImageElements.
  preparePlaceholder() {
    const image = new Image();
    image.src = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(
      IMAGE_PLACEHOLDER
    )}`;
    // if ('decode' in HTMLImageElement.prototype) {
    image
      .decode()
      .then(() => {
        this.placeholderImage = image;
      })
      .catch(encodingError => {
        console.error('Error decoding placeholder image', encodingError);
      });
    // }
  },

  renderPlaceholder(
    ctx: CanvasRenderingContext2D,
    obj: { width: number; height: number }
  ) {
    ctx.lineWidth = 2;
    ctx.strokeStyle = '#cccccc';
    ctx.strokeRect(-obj.width / 2, -obj.height / 2, obj.width, obj.height);
    ctx.fillStyle = '#f9f9f9';
    ctx.fillRect(-obj.width / 2, -obj.height / 2, obj.width, obj.height);

    // Size the placeholder image. Assumes square placeholder.
    const controllingDimension = Math.min(obj.width, obj.height) * 0.6;
    if (PlaceholderImageCache.placeholderImage) {
      ctx.drawImage(
        PlaceholderImageCache.placeholderImage,
        -controllingDimension / 2,
        -controllingDimension / 2,
        controllingDimension,
        controllingDimension
      );
    }
  },
};

export default PlaceholderImageCache;
